import api from 'services/api';

const base = '/comercial/comissoes';
const unwrap = (response) => response.data?.data;

/** Nome do arquivo que o backend mandou no `Content-Disposition`; sem ele, o padrão da tela. */
export const nomeDoAnexo = (contentDisposition, padrao) => {
  const bruto = String(contentDisposition || '');
  const casado = bruto.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  return casado ? decodeURIComponent(casado[1].trim()) : padrao;
};

const comissaoReguaService = {
  configuracao: () => api.get(`${base}/configuracao`).then(unwrap),
  salvarConfiguracao: (inicio_vigencia) => api.put(`${base}/configuracao`, { inicio_vigencia }).then(unwrap),
  competencia: (mes) => api.get(`${base}/${mes}`).then(unwrap),
  // `atualizar` pede uma leitura nova do IXC em vez do cache de 5 min (o backend limita a frequência).
  previa: (mes, atualizar = false) => api.get(`${base}/${mes}/previa`, { params: atualizar ? { atualizar: 1 } : {} }).then(unwrap),
  vendedores: () => api.get(`${base}/vendedores-ativos`).then(unwrap),
  salvarRegra: (mes, payload) => api.put(`${base}/${mes}/regra`, payload).then(unwrap),
  salvarMetas: (mes, payload) => api.put(`${base}/${mes}/metas`, payload).then(unwrap),
  copiarAnterior: (mes) => api.post(`${base}/${mes}/copiar-anterior`).then(unwrap),
  // Recalculo proporcional das metas. `payload` leva `total` OU `segmentos`; a simulação não grava,
  // e o `PUT` reenvia a `versao_configuracao` que ela devolveu (409 se a competência mudou no meio).
  simularMetaTotal: (mes, payload) => api.post(`${base}/${mes}/meta-total/simulacao`, payload).then(unwrap),
  salvarMetaTotal: (mes, payload) => api.put(`${base}/${mes}/meta-total`, payload).then(unwrap),
  fechar: (mes) => api.post(`${base}/${mes}/fechar`).then(unwrap),
  reabrir: (mes, justificativa) => api.post(`${base}/${mes}/reabrir`, { justificativa }).then(unwrap),
  historico: (mes) => api.get(`${base}/${mes}/historico`).then(unwrap),
  // Série das competências já FECHADAS, para progressão por vendedor. Não passa pelo IXC.
  serie: (meses = 12) => api.get(`${base}/serie`, { params: { meses } }).then(unwrap),
  // Subaba do vendedor. O recorte é do backend: `vendedorId` só é aceito de quem tem `comercial.view`.
  // `atualizar` pede uma leitura nova do IXC em vez do cache de 5 min (o backend limita a frequência).
  // Meta do dia da equipe interna no mês e vendas de hoje por hora. Sempre o mês corrente.
  ritmoDaEquipe: () => api.get('/comercial/ritmo-da-equipe').then(unwrap),
  minhasVendas: (mes, vendedorId, atualizar = false) => api
    .get(`/comercial/minhas-vendas/${mes}`, { params: { ...(vendedorId ? { vendedor_id: vendedorId } : {}), ...(atualizar ? { atualizar: 1 } : {}) } })
    .then(unwrap),
  exportarMinhasVendas: (mes, formato, vendedorId) => api
    .get(`/comercial/minhas-vendas/${mes}/exportar/${formato}`, { params: vendedorId ? { vendedor_id: vendedorId } : {}, responseType: 'blob' })
    .then((response) => ({
      blob: response.data,
      nome: nomeDoAnexo(response.headers?.['content-disposition'], `minhas-vendas-${mes}.${formato}`),
    })),
  // Consulta cruzada: o backend escolhe XT ou MOV pelo contexto da empresa atual.
  consultarInterempresa: (documento) => api.post('/comercial/consulta-interempresa', { documento }).then(unwrap),
  usuariosParaVinculo: () => api.get('/comercial/vendedores/usuarios').then(unwrap),
  vincularUsuario: (vendedorId, userId, vendedorNome) => api
    .put(`/comercial/vendedores/${vendedorId}/usuario`, { user_id: userId, vendedor_nome: vendedorNome })
    .then(unwrap),
  desvincularUsuario: (vendedorId) => api.delete(`/comercial/vendedores/${vendedorId}/usuario`).then(unwrap),
  /**
   * Baixa o documento oficial PELO axios, e não por um `<a href>`.
   *
   * O link direto tinha dois defeitos: o caminho era relativo à origem — o navegador resolvia
   * contra o domínio da tela, caía no React Router e respondia 404 — e, mesmo com a URL certa, uma
   * navegação não leva o `Authorization` nem o `X-Company-Id` que o interceptor acrescenta, então a
   * rota responderia 401 ou erraria o tenant.
   */
  baixarDocumento: (mes, apuracao, formato) => api
    .get(`${base}/${mes}/apuracoes/${apuracao}/documentos/${formato}`, { responseType: 'blob' })
    .then((response) => ({
      blob: response.data,
      nome: nomeDoAnexo(response.headers?.['content-disposition'], `comissao-${mes}-rev${apuracao}.${formato}`),
    })),
};

export default comissaoReguaService;
